import React from 'react';
import { PageHeader } from 'antd';

const Backend = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Серверная часть"
            />
            <p>Серверная часть приложения предоставлена RS School:</p>
            <p><a href="https://rs-react-schedule.firebaseapp.com/api/docs/#/">https://rs-react-schedule.firebaseapp.com/api/docs/#/</a></p>
            <p>В качестве team id использовался номер 46</p>
            <p>Сменить team id можно в src/api/eventsAPI.ts: <code> const teamId = '46';</code></p>
            <p>Объект event, по сравнению с исходным в примере get - response, был изменен на объект следующей структуры:</p>
            <code>
                &#123;<br/>
                id: string;<br/>
                name: string;<br/>
                author: string;<br/>
                tag: Array&lt;string&gt;;<br/>
                date: string;<br/>
                deadline: string;<br/>
                duration: number;<br/>
                description: string;<br/>
                result: string;<br/>
                remark: string;<br/>
                links: Array&lt;string&gt;;<br/>
                photo: boolean;<br/>
                video: boolean;<br/>
                map: string;<br/>
                rating: Array&lt;number&gt;;<br/>
                feedback: Array&lt;string&gt;;<br/>
                allowFeedback: boolean;<br/>
                &#125;
            </code><br/><br/>
            <p>Часть бэкенда - organizers - не использовалась, автор задачи хранится в объекте задачи</p>
        </>
    );
};

export default Backend;